enum recordConstants {
  RECORD_STATUS_ERROR = -3,
  RECORD_STATUS_WRONG_RECORD_LOADED = -2,
  RECORD_STATUS_NO_DATA = -1,
  RECORD_STATUS_READY = 0,
  RECORD_STATUS_LOADING = 1
}

export default recordConstants;
